import { useAuth } from '../contexts/AuthContext';

export const useApi = () => {
  const { refreshToken, logout } = useAuth();

  const apiCall = async (url, options = {}) => {
    const token = localStorage.getItem('token');
    
    // Add authorization header if token exists
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const config = {
      ...options,
      headers,
    };

    try {
      const response = await fetch(url, config);
      
      // If we get a 401, try to refresh the token and retry
      if (response.status === 401 && token) {
        const newToken = await refreshToken();
        if (newToken) {
          // Retry the request with the new token
          const retryHeaders = {
            ...headers,
            Authorization: `Bearer ${newToken}`,
          };
          
          const retryConfig = {
            ...config,
            headers: retryHeaders,
          };
          
          const retryResponse = await fetch(url, retryConfig);
          return retryResponse;
        } else {
          // Refresh failed, user will be logged out
          throw new Error('Authentication failed');
        }
      }
      
      return response;
    } catch (error) {
      console.error('API call error:', error);
      throw error;
    }
  };

  return { apiCall };
};
